/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useMemo, useEffect } from 'react';
import { cache } from '@/utils';
import ossImgCompress from '@/utils/ossImgCompress';
import { useGetConfig } from '../../useGetConfig';
import styles from './index.module.less';

const PanoramicVideo = () => {
  const {
    panoramicVideo,
    mobxStore: { app, area, product },
  } = useGetConfig();
  const { webp, isLocal, isProd, isMobile } = app;
  const { country, LANG } = area;
  const { curSelectCommodityId: cid } = product;
  const [isLoaded, setIsLoaded] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const coverImage = () => {
    if (panoramicVideo) {
      return isMobile ? panoramicVideo.mo_cover_image : panoramicVideo.pc_cover_image;
    }
    return '';
  };

  const video_data = useMemo(() => {
    setIsLoaded(false);

    const panoramic = panoramicVideo;
    /** 目标全景图片 */
    const target_url = panoramic?.img_url;
    /** 傀儡图片资源 */
    const puppet_url = isProd ? '091cfca50c80802f1fb7e988f117531b' : 'b4890ef026b3c079285d348f953e81ea';

    const domains = {
      /** 没有本地启动 share 进行调试的情况下需要在本地预览 将 local 的 path 替换为 dev 即可 */
      // local: `https://s-test.insta360.com/p/${puppet_url}`,
      local: `http://localhost:7001/p/${puppet_url}`,
      dev: `https://s-test.insta360.com/p/${puppet_url}`,
      prod: `https://s.insta360.com/p/${puppet_url}`,
    };
    /** share 只有 local、test、prod  */
    const baseUrl = isLocal ? domains.local : isProd ? domains.prod : domains.dev;

    /**
     * @param {origin} 不知道什么 反正必须要
     * @param {source} 指定入口
     * @param {url} 展示的图片链接
     * @param {local} 指定语言
     * @param {isMo} 是否是mo
     * @param {env} 环境
     */
    const q = new URLSearchParams({
      origin: 'dashboard',
      source: 'store',
      url: target_url ?? '',
      locale: country.X_Language,
      isMo: `${isMobile}`,
      env: window.location.hostname.split('.insta360.com')[0],
      isGrayTest: cache.getCookie('gray_test') ?? '0',
    }).toString();

    return {
      iframeUrl: `${baseUrl}?${q}`,
    };
  }, [cid]);

  window.addEventListener('message', (event) => {
    if (event.data.type === 'insta_panoramic') {
      setIsLoaded(true);
    }
  });

  useEffect(() => {
    const img_url = ossImgCompress(coverImage(), { webp });
    const img = new Image();
    img.src = img_url;
    img.onload = () => setIsShow(true);
    img.onerror = () => setIsShow(false);
  }, [cid]);

  return (
    <div className={styles.videoContainer}>
      <div
        className={styles.videoMask}
        data-load={isLoaded}
        data-loading={isShow}
        style={{
          backgroundImage: isShow
            ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("${ossImgCompress(coverImage(), {
                webp,
              })}")`
            : `linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)), url("${ossImgCompress(coverImage(), {
                webp,
              })}")`,

          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className={styles.bg}>
          <div className={styles.text}>
            <div className={styles.gif}></div>
            <p className={styles.title}>{LANG['productNew.Display.panoramic_video_tips_1']}</p>
          </div>
        </div>
      </div>

      <iframe
        ref={iframeRef}
        data-load={isLoaded}
        className={styles.videoIframe}
        data-show={isLoaded}
        scrolling='no'
        loading='eager'
        src={video_data.iframeUrl}
      />
    </div>
  );
};

export default PanoramicVideo;
